import { mergeReducers } from 'utils/redux'

import contacts from 'modules/contacts/reducer'
import imports from 'modules/imports/reducer'
import segments from 'modules/segments/reducer'
import segmentList from 'modules/segment_list/reducer'
import settings from 'modules/settings/reducer'
import sfdcEnrichment from 'modules/sfdc/reducer'
import hubSpotEnrichment from 'modules/hubspot/reducer'
import singleContact from 'modules/contact_detail/reducer'
import filterBuilder from 'modules/filter_builder/reducer'
import filterBuilderEpic from 'modules/filter_builder/epic'

export const rootReducer = mergeReducers({
  contacts,
  singleContact,
  imports,
  segments,
  segmentList,
  settings,
  sfdcEnrichment,
  hubSpotEnrichment,
  filterBuilder
})

export const rootEpic = [
  filterBuilderEpic
]